import config from '../config.json';

export const getApiBaseUrl = () => {
    const host = window.location.host;
    const domain = 'prosolve.com';
    const subDomain = 'go';
    const apiSubDomain = 'api';

    if (host.indexOf('localhost') > -1) {
        return `http://localhost:${config.port}/api`;
    }

    // detect env
    const parts = host.split('.');
    // Only qa/uat are real environments; any other segment before 'prosolve.com' means prod
    const envPart = parts[parts.length-3];
    const env = ['qa', 'uat'].includes(envPart) ? `.${envPart}` : '';
    return `https://${apiSubDomain}.${subDomain}${env}.${domain}/api`
}

export default () => {
    const apiBaseUrl = getApiBaseUrl();

    return async (url, ...args) => {
        return await fetch(`${apiBaseUrl}/${url}`, ...args)
    }
};
